import React from 'react';
import classNames from 'classnames';
import styles from '../../EditorCommon.module.scss';

export default function LongTextQuestionDetail() {
  return (
    <div className={classNames(styles['long-text-detail'], 'long-text-detail')}>
      <textarea disabled rows={2}></textarea>
    </div>
  );
}
